<template>
    <div class="eventApplicationModal">
        <div class="header header-registered u-text-center">
            <div class="status">
                <template v-if="isReservoir">リザーバー応募受付</template>
                <template v-else-if="isArrivingFirst">先着応募受付</template>
                <template v-else-if="isDrawing">抽選応募受付</template>
            </div>
            <div class="c-title c-title-page-league u-mb">
                {{ '【' + eventName + '】' }}
            </div>
            <div class="league">◆{{ eventData.leagueTitle + 'リーグ' }}</div>
        </div>
        <error-msg class="u-mb-lg">
            <template v-if="message">
                <p class="c-warningBox-icon u-text-bold u-text-normal u-mb newLine" >{{ message }}</p>
            </template>
            <template v-else>
                <p class="c-warningBox-icon u-text-bold u-text-normal u-mb newLine" >応募に失敗しました。画面を再読み込みして再度応募を実施してください。</p>
            </template>
            <p v-if="isEntryMessage" class="u-text-black u-text-small error-msg">応募済みのイベントは、マイページの「出場予定のイベント」からご確認ください。</p>
        </error-msg>
        <div class="u-text-center to-mypage">
            <router-link
                :to="{name: 'Mypage'}"
                class="c-btn c-btn-primary-outline sp-width-100"
            >
                マイページへ
            </router-link>
        </div>
    </div>
</template>

<script>
import errorMsg from '@/component/ErrorMsg.vue'

export default {
    components: {
        errorMsg,
    },
    props: {
        eventData: {
            type: Object,
            default() {
                return {}
            }
        },
        isArrivingFirst: {
            type: Boolean,
            default: false,
        },
        isDrawing: {
            type: Boolean,
            default: false,
        },
        isReservoir: {
            type: Boolean,
            default: false,
        },
        message: {
            type: String,
            default: '',
        },
        isEntryMessage: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
        }
    },
    computed: {
        eventName() {
            return (this.eventData.orgEventTitle ? this.eventData.orgEventTitle : this.eventData.eventTitle) + ' ' + this.eventData.leagueTitle
        }
    },
    created: function() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
@use '../../style/applicationModal';
</style>
